function versions () {
    var u = window.navigator.userAgent
    return {
      // IE内核
      trident: u.indexOf('Trident') > -1,
      // opera内核
      presto: u.indexOf('Presto') > -1,
      // 苹果、谷歌内核
      webKit: u.indexOf('AppleWebKit') > -1,
      // 火狐内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1,
      // 是否为移动终端 / Tablets use desktop version
      mobile: (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) && !(/Tablet|iPad/i.test(navigator.userAgent))||window.innerWidth<900,
      // ios终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      // android终端或者uc浏览器
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
      // 是否为iPhone或者安卓QQ浏览器
      iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1,
      // 是否为iPad
      iPad: u.indexOf('iPad') > -1,
      // 是否为web应用程序，没有头部与底部
      webApp: u.indexOf('Safari') === -1,
      // 是否为微信浏览器
      weixin: ~u.indexOf('MicroMessenger')
    }
  }
  
  export default versions()


// WEBPACK FOOTER //
// ./src/utils/browser.js